import { render, staticRenderFns } from "./LawMatterTradeFairEmployeeForm.vue?vue&type=template&id=e53f396e&"
import script from "./LawMatterTradeFairEmployeeForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterTradeFairEmployeeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterTradeFairEmployeeForm.vue?vue&type=style&index=0&id=e53f396e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports